module.exports = __webpack_public_path__ + "img/05.11545d27.gif";